import useDateFormat from "hooks/useDateFormat";
import { useRCAHistoryMainStyles } from "../../RCA.styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const RCADueDateLog = ({ newValue, oldValue }: { newValue: string | null; oldValue: string | null }) => {
    const classes = useRCAHistoryMainStyles();
    const { formatDate } = useDateFormat();

    return (
        <div className={classes.historyChangeWrapper}>
            <span className={classes.historyText}>{formatDate(new Date(oldValue || ""), true)}</span>{" "}
            <ArrowForwardIcon />{" "}
            <span className={classes.historyText}>{formatDate(new Date(newValue || ""), true)}</span>
        </div>
    );
};
